import { render, staticRenderFns } from "./server-count.vue?vue&type=template&id=289465b4&scoped=true&"
import script from "./server-count.vue?vue&type=script&lang=js&"
export * from "./server-count.vue?vue&type=script&lang=js&"
import style0 from "./server-count.vue?vue&type=style&index=0&id=289465b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289465b4",
  null
  
)

export default component.exports